import { getCookie } from 'utils/cookies';
import {
  fetchUserSubscriptionStatusFromApi,
  buildSubsData,
  getPrcCookieValue,
  tempPrcUserSetData,
  storeRequiredKeysInBrowser,
} from 'utils/primeUtil';
import makeRequest from 'utils/makeRequest';
import { setIbeattrack } from 'utils/iBeatConfig';
import {
  TOI_SUBS_PLAN_STATUS_MWEB_V2,
  TOI_SUBS_PLAN_STATUS_WEB_V2,
  TOI_X_CLIENT_ID_WAP,
  TOI_X_CLIENT_ID_WEB,
  TOI_X_SITE_APP_CODE,
} from '../../constants';
import reducerRegistry from '../../reduxUtils/reducerRegistry';

const reducerName = 'login';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
//export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const USER_PRC_DATA = createActionName('USER_PRC_DATA');
export const USER_DATA = createActionName('USER_DATA');
export const OPEN_LOGIN = createActionName('OPEN_LOGIN');
export const LOADING = createActionName('LOADING');
export const USER_LOGIN_STATUS = createActionName('USER_LOGIN_STATUS');
export const LOADING_STATE = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  DONE: 'DONE',
};
// action creators
export function userData(data) {
  return {
    type: USER_DATA,
    payload: {
      userData: data,
    },
  };
}

export function isLoading(value) {
  return {
    type: LOADING,
    payload: value,
  };
}

export function userPrcData(data) {
  return {
    type: USER_PRC_DATA,
    payload: {
      userPrcData: data,
    },
  };
}

function fetchCentralSubsData() {
  const options = {};
  const ssoId = getCookie('ssoid');
  const ticketId =
    getCookie('TicketId') || getCookie('Ticketid') || getCookie('ticketId');
  const requestUrl =
    window && window.App && window.App.state && window.App.state.isMobile
      ? TOI_SUBS_PLAN_STATUS_MWEB_V2
      : TOI_SUBS_PLAN_STATUS_WEB_V2;
  const clientId =
    window && window.App && window.App.state && window.App.state.isMobile
      ? TOI_X_CLIENT_ID_WAP
      : TOI_X_CLIENT_ID_WEB;
  options.headers = {
    'X-SSO-ID': ssoId,
    'X-TICKET-ID': ticketId,
    'X-CLIENT-ID': clientId,
    'X-DEVICE-ID': '123-132-321-432',
    'X-SITE-APP-CODE': TOI_X_SITE_APP_CODE,
  };
  return makeRequest.get(`${requestUrl}`, options);
}

export function getUserPrcData() {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(isLoading(LOADING_STATE.LOADING));

      fetchCentralSubsData()
        .then(async response => {
          if (response && response.data) {
            const fetchedUserData = tempPrcUserSetData() || response?.data;
            const subsData = buildSubsData(fetchedUserData?.data);

            if (subsData) {
              await storeRequiredKeysInBrowser({
                prc: subsData.planStatus,
                token: subsData.token,
              });

              await new Promise(_resolve => setTimeout(_resolve, 100));

              const prcValue = getPrcCookieValue();

              await fetchUserSubscriptionStatusFromApi(subsData);

              if (prcValue || prcValue === 0) {
                dispatch(
                  userData({
                    isLoggedIn: true,
                    prcValue,
                  }),
                );
                if (typeof window !== 'undefined' && window._ibeat_track) {
                  window._ibeat_track = window._ibeat_track || {};
                  setIbeattrack({
                    ...window._ibeat_track,
                    pc: subsData?.planStatus,
                  });
                }
                dispatch(userPrcData(subsData));
                dispatch(isLoading(LOADING_STATE.DONE));
                return resolve(subsData);
              }
            }
          }
          dispatch(isLoading(LOADING_STATE.DONE));
          resolve(null);
        })
        .catch(error => {
          dispatch(isLoading(LOADING_STATE.DONE));
          reject(error);
        });
    });
}

export function toggleLoginBox(isOpen, userEmailid = '') {
  return {
    type: OPEN_LOGIN,
    payload: {
      openLogin: isOpen,
      userEmailid,
    },
  };
}
// export function userLoginStatus(data) {
//   return {
//     type: USER_LOGIN_STATUS,
//     payload: {
//       userData: data,
//     },
//   };
// }

// reducer
export default function reducer(state = { userPrcData: null }, action = {}) {
  switch (action.type) {
    case USER_DATA: {
      const uData = state.userData || {};
      return {
        ...state,
        userData: {
          ...uData,
          ...action.payload.userData,
        },
      };
    }
    case USER_PRC_DATA: {
      const uData = state.userPrcData || {};
      return {
        ...state,
        userPrcData: {
          ...uData,
          ...action.payload.userPrcData,
        },
      };
    }
    case OPEN_LOGIN:
      return {
        ...state,
        openLogin: action.payload.openLogin,
        userEmailid: action.payload.userEmailid,
      };
    // case USER_LOGIN_STATUS:
    //   return {
    //     ...state,
    //     userData: action.payload.userData,
    //   };
    case LOADING:
      return {
        ...state,
        isLoading: action.payload || LOADING_STATE.IDLE,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
